import React, {useEffect, useRef} from 'react';
import './EmbedCasesPage.scss';
import {Container} from "react-bootstrap";
import CaseGenerator from "../../CaseGenerator/CaseGenerator";
import {CaseForms} from "../../../helpers/enums";
import {Redirect} from "react-router-dom";

import useResizeObserver from '@react-hook/resize-observer'
import Configuration from "../../../config";


const EmbedCasesPage = props => {
  const realMatch = props.match || props.computedMatch;
  const params = realMatch.params;
  const {type} = params;
  const containerRef = useRef(null);

  const publicCases = [
    'richiedi-informazioni',
    'segnala-un-guasto',
    'fai-un-reclamo',
    // 'richiedi-omaggio',
    'appuntamento-punto-acqua',
    'richiesta-spurgo',
    'aggiorna-dati'
  ];
  const getType = () => {
    const mapping = {
      'richiedi-informazioni': CaseForms.RichiediInformazioni,
      'segnala-un-guasto': CaseForms.SegnalaUnGuasto,
      'fai-un-reclamo': CaseForms.FaiUnReclamo,
      // 'richiedi-omaggio': CaseForms.RichiediOmaggio,
      'appuntamento-punto-acqua': CaseForms.AppuntamentoPuntoAcqua,
      'richiesta-spurgo': CaseForms.RichiediSpurghiCase,
      'aggiorna-dati': CaseForms.AggiornaDati
    }
    return mapping[type];
  }

  useEffect(() => {
    document.body.classList.add('embed-case');
    return () => {
      document.body.classList.remove('embed-case');
    }
  }, []);

  const onResize = (entry) => {
    console.log("auto resizing page")

    window.top.postMessage({type: 'gcapCaseResize', height: entry.contentRect.height, width: entry.contentRect.width}, Configuration.get('REACT_APP_GCAP_PUBLIC_HOST'));
  }

  useResizeObserver(containerRef, onResize)

  if (!type) {
    return <Redirect to={'/login'} />;
  }

  if (!publicCases.includes(type)) {
    return <Redirect to={'/login'} />;
  }

  return (
    <div className="EmbedCasesPage" data-testid="EmbedCasesPage">
      <Container ref={containerRef}>
        <CaseGenerator
          type={getType()}
          formOnly={true}
          title={false}
          embed={true}
        />
      </Container>
    </div>
  )
};

EmbedCasesPage.propTypes = {};

export default EmbedCasesPage;
